<template>
  <div class="w-96 md:w-full h-full relative">
    <div
      id="uniqueChoie"
      ref="uniqueChoie"
      class="w-full h-full border rounded-lg flex items-center px-2"
      @click.stop="renderOptions"
    >
      <span class="truncate w-full inline-block">{{ answer }} </span>
      <div class="flex flex-col cursor-pointer">
        <i class="material-icons p-0 m-0" style="font-size: 22px; line-height: 0.4"> arrow_drop_up </i>
        <i class="material-icons p-0 m-0" style="font-size: 22px; line-height: 0.4"> arrow_drop_down </i>
      </div>
    </div>

    <div ref="nodeListOptions" class="ccf746de-a382-4581-a246-92482498152c absolute mt-10 bg-white w-full z-1000">
      <ul class="bg-white z-1000 border w-full heightListOptions overflow-auto rounded">
        <li class="px-2 py-2 flex items-center border border-r-0 border-t-0 border-l-0 sticky top-0 bg-white">
          <i class="material-icons p-0 m-0 mr-2" style="font-size: 16px; line-height: 0.4"> search </i>
          <input
            v-model.trim="searchOption"
            class="w-full h-6 border-0 font-family"
            type="text"
            @click.stop
            placeholder="Buscar..."
          />
        </li>
        <li
          class="px-2 py-1 cursor-pointer Options_"
          :class="{ optionSelected: option === optionSelected }"
          v-for="(option, j) in filterOptions"
          :key="j"
          @click="selectedOption(option)"
        >
          {{ option }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  props: {
    value: {
      type: String,
      required: false
    },
    Item: {
      type: Object,
      required: true,
      default: ""
    },
    question: {
      type: Object,
      required: true
    },
    change: {
      type: Promise | Function,
      required: true,
      default: () => {}
    }
  },
  async mounted() {
    this.nodeListOptions = this.$refs.nodeListOptions;
    const existElements =  document.getElementsByClassName("ccf746de-a382-4581-a246-92482498152c");
    if (existElements.length > 0) this.removeElements();
  },
  data() {
    return {
      nodeListOptions: null,
      optionSelected: "",
      item: this.Item,
      searchOption: ""
    };
  },
  methods: {
    selectedOption(text) {
      this.answer = text;
      this.removeElements();     
    },
    renderOptions() {
      this.searchOption = "";
      const body = document.body;
      body.onclick = () => this.removeElements();

      if (this.isDisplay()) return this.removeElements();

      const existElements = document.getElementsByClassName("ccf746de-a382-4581-a246-92482498152c");
      if (existElements.length > 0) this.removeElements();

      const uniqueChoie = this.$refs.uniqueChoie;
      const currendDiv = uniqueChoie.parentNode;

      currendDiv.insertBefore(this.nodeListOptions, uniqueChoie);
    },
    removeElements() {
      const elements = document.getElementsByClassName("ccf746de-a382-4581-a246-92482498152c");
      while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0]);
      }
    },
    isDisplay() {
      return this.$refs.nodeListOptions.offsetWidth > 0 ? true : false;
    }
  },
  computed: {
    options() {
      return this.question.options;
    },
    filterOptions() {
      return this.options.filter(option => {
        if (this.searchOption.length > 0) {          
          return option.toLowerCase().includes(this.searchOption.toLowerCase());
        }
        return true;
      });
    },
    answer: {
      get() {
        return this.value;
      },
      set(value) {
        this.change(value, this.Item);
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.font-family {
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 12px;
}
.heightListOptions {
  max-height: 16rem;
}

.z-1000 {
  z-index: 1000000;
}

.Options_:hover {
  background-color: #e6e6e6;
}

.optionSelected {
  background-color: #e6e6e6;
}
</style>
